import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { has } from 'lodash';
import changeReducerFactory from './factories/changeReducerFactory';
import detailReducerFactory from './factories/detailReducerFactory';
import entityReducerFactory from './factories/entityReducerFactory';
import employeeConstants from '../constants/employeeConstants';
import mfaConstants from '../constants/mfaConstants';
import applyReducer, { reduceReducers } from './applyReducer';
const changeReducer = changeReducerFactory('employee');
const detailReducer = detailReducerFactory('employee');
const entityReducer = entityReducerFactory('employee');
const defaultIndexQuery = _objectSpread(_objectSpread({}, entityReducer.initState.indexQuery), {}, {
  filters: {
    status: '1',
    jobs: []
  },
  sortDirection: 'DESC'
});
const initState = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, changeReducer.initState), detailReducer.initState), entityReducer.initState), {}, {
  activeRemotePath: null,
  hasPrevious: false,
  hasNext: false,
  indexQuery: defaultIndexQuery,
  initialIndexQuery: defaultIndexQuery,
  permissions: {
    view: {
      include: ['user_edit', 'job_edit', 'asset_admin']
    },
    edit: {
      include: ['user_edit']
    }
  }
});

/**
 * @func saveSuccess - remove password from state on successful save.
 * @param {Object} state - current state
 */
const saveSuccess = state => {
  const active = state.active;
  delete active.password;
  return _objectSpread(_objectSpread({}, state), {}, {
    active
  });
};

/**
 * @func mfaSaveSuccess - saved MFA secret.  if active employee, set mfaEnabled == true
 * @param {Object} state - current state
 */
const mfaSaveSuccess = state => {
  const active = state.active;
  if (has(active, 'id')) {
    active.mfaEnabled = true;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    active
  });
};

/**
 * @func mfaDeleteSuccess - deleted MFA secret.  if active employee, set mfaEnabled == true
 * @param {Object} state - current state
 */
const mfaDeleteSuccess = state => {
  const active = state.active;
  if (has(active, 'id')) {
    active.mfaEnabled = false;
  }
  return _objectSpread(_objectSpread({}, state), {}, {
    active
  });
};
const reducers = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, changeReducer.reducers), detailReducer.reducers), entityReducer.reducers), {}, {
  [employeeConstants.SAVE_SUCCESS]: reduceReducers(changeReducer.reducers[employeeConstants.SAVE_SUCCESS], saveSuccess),
  [mfaConstants.MFA_SAVE_SUCCESS]: mfaSaveSuccess,
  [mfaConstants.MFA_DESTROY_SUCCESS]: mfaDeleteSuccess
});
export default applyReducer(reducers, initState);